const openQuickShopModal = (product) => {
  // The "product" parameter contains values from the tolstoy spotlight carousel that you can use as a handle into which values to render on the modal.
  //You can check the values by logging it.
  console.log(product);
  var productUrl = 'https://patrickta.com/products/' + product.handle; 
  fetch(productUrl)
      .then((response) => response.text())
      .then((responseText) => {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        const destination = document.querySelector('.shopify-section--main-product');
        const source = html.querySelector('.shopify-section--main-product');
        const quickBuyContent = html.getElementById('quick-buy-content').content;
        Array.from(quickBuyContent.querySelectorAll('noscript')).forEach(noScript => noScript.remove());
        const quickBuyModal = document.createElement('quick-buy-modal');
            quickBuyModal.setAttribute('handle', product.handle);
            quickBuyModal.setAttribute('class', 'quick-buy-modal modal tolstoy-product-quick-shop');
            quickBuyModal.setAttribute('role', 'dialog');
            quickBuyModal.setAttribute('aria-modal', 'true');
            quickBuyModal.setAttribute('open', '');
            quickBuyModal.style.display = 'block';
            quickBuyModal.style.opacity = '1';
        quickBuyModal.innerHTML = ''; // Clear any existing content
        quickBuyModal.appendChild(quickBuyContent.cloneNode(true));
        const footer = document.querySelector('footer');
            footer.parentNode.insertBefore(quickBuyModal, footer.nextSibling);
       const htmlElement = document.documentElement; 
            htmlElement.classList.add('lock');
      });
  
  // Please put the function that will open your quick shop modal with their corresponding values here.
}
//This Function is for the onClick Function on Tolstoy Spotlight Carousel "+" button
const subscribeToQuickShopClick =() =>  {
  window.tolstoyWidget.subscribe(
    "tolstoy_spotlight_carousel_quick_shop_click",
     (o) => {o.product && o.product.handle? openQuickShopModal(o.product): console.error("Product handle is not available in the event");},
    { disableDefault: !0 },
  );
}

window.tolstoyWidget ? subscribeToQuickShopClick(): window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);
